import { render } from "./ModernCard.vue?vue&type=template&id=5545d3f4"
import script from "./ModernCard.vue?vue&type=script&lang=js"
export * from "./ModernCard.vue?vue&type=script&lang=js"
script.render = render

export default script